import PaymentRequestsDetailsModal from './index.vue'
export default PaymentRequestsDetailsModal